import { FilterType } from '../types/filterTypes';
import { AccountStatus } from '../../../../interfaces/ManageUsers';
export const FILTER_CATEGORIES = {
    booleanFilters: [
        'EmailStatus',
        'WelcomeEmailSent',
        'Auditor',
        'Treasurer',
        'Translator',
        'AccountsPayable'
    ],
    valueFilters: [
        'UserEmail',
        'FirstName',
        'LastName',
        'EmployeeID',
        'AdminLevel',
        'Role',
        'DepartmentName',
        'ApproverEmail',
        'AccountantEmail',
        'DateCreatedStart',
        'DateCreatedEnd',
        'ApprLimitPK',
        'EmpUDF1PK',
        'EmpUDF2PK',
        'EmpUDF3PK',
        'EmpUDF4PK',
        'EmpUDF5PK'
    ],
    specialFilters: ['AccountStatus']
};
export const ROLE_MAP = {
    [FilterType.Approver]: { email: 'ApproverEmail', pk: 'ApproverPK' },
    [FilterType.Accountant]: { email: 'AccountantEmail', pk: 'AccountantPK' }
};
export const FILTER_DEFAULTS = {
    EMPTY_USERNAME: '',
    DEFAULT_STATUS: AccountStatus.All
};
